module.exports = __webpack_public_path__ + "static/img/OPEN AI SORA.635e969f.png";